import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
import Button from '../Button';

const CookieConsent = () => {
  const [showCookie, setShowCookie] = useState(false);

  useEffect(() => {
    // Check if user has already made a cookie preference decision
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    if (!cookieConsent) {
      // Show cookie banner after page fully loads
      const timer = setTimeout(() => {
        setShowCookie(true);
      }, 3500); // Delay to ensure page is fully loaded
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowCookie(false);
  };

  const handleDeny = () => {
    localStorage.setItem('cookieConsent', 'denied');
    setShowCookie(false);
  };

  if (!showCookie) return null;

  return (
    <div className='cookie-consent-container'>
      <div className='cookie-consent-content'>
        <div className='cookie-consent-text'>
          <h3>Cookie Preferences</h3>
          <p>
            We use cookies to enhance your experience, analyze site traffic, and personalize content. 
            By continuing to use our site, you consent to our use of cookies.
          </p>
        </div>
        <div className='cookie-consent-buttons'>
          <Button 
            buttonStyle='btn--outline' 
            buttonSize='btn--medium'
            onClick={handleDeny}
          >
            Deny
          </Button>
          <Button 
            buttonStyle='btn--primary' 
            buttonSize='btn--medium'
            buttonColor='blue'
            onClick={handleAccept}
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
